module.exports = __webpack_public_path__ + "static/media/search-right.fbc4af15.svg";